<sc-flex fitHeight vertical stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.title"></sc-dictionary-label>
  </sc-dialog-title>
  @if (this.registration!= null && this.registration.transport != null) {
    <div class="stepper-title-bar">
      @for (st of stepperModel.componentTitles; track st; let i = $index) {
        <div class="title-part">
          @if (i>0) {
            <div class="divider">></div>
          }
          <div class="step-title"
            [ngClass]="{'active': stepperModel.currentComponentIndex >= i, 'disabled': i==2 && this.registration.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE}">
            <sc-dictionary-label [dictionaryKey]="st"></sc-dictionary-label>
          </div>
        </div>
      }
    </div>
  }
  <sc-flex-fitting-content vertical>
    @if (registration) {
      @if (this.stepperModel.currentComponentIndex === 0) {
        <app-master-data [readonly]="readonly" [registration]="registration" [stepperModel]="stepperModel"
        (valueChange)="handleValueChange()"></app-master-data>
      }
      @if (this.stepperModel.currentComponentIndex === 1) {
        <app-transport-options [registration]="registration" [stepperModel]="stepperModel"
        ></app-transport-options>
      }
      @if (this.stepperModel.currentComponentIndex === 2) {
        <app-route [registration]="registration" [stepperModel]="stepperModel"
        ></app-route>
      }
      @if (this.stepperModel.currentComponentIndex === 3) {
        <app-supplementary-equipment [registration]="registration" [stepperModel]="stepperModel"
        ></app-supplementary-equipment>
      }
    }
  </sc-flex-fitting-content>
  <div class="messages">
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
  </div>
  <sc-padding [formGroup]="formGroup">
    <sc-flex>
      @if (isPreviousStepVisible()) {
        <sc-back-button dictionaryKey="tmc-yard.common.action.previous" (click)="showPreviousStep()" [disabled]="showPreviousStepDisabled()"
        ></sc-back-button>
      }
      @if (this.stepperModel.currentComponentIndex === 0) {
        <sc-content-spacer grow></sc-content-spacer>
        <sc-checkbox-field formControlName="registerArrival" labelDictionaryKey="tmc-yard.ui.transport-registration.checkbox.register-arrival"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-checkbox-field formControlName="registerEntrance" labelDictionaryKey="tmc-yard.ui.transport-registration.checkbox.register-entrance"></sc-checkbox-field>
      }
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" [disabled]="isCancelDisabled()" class="cancel-button"
      (click)="cancel()"></sc-cancel-button>
      @if (showNextStepButtonVisible()) {
        <sc-content-spacer></sc-content-spacer>
        <sc-forward-button iconPosition="right" dictionaryKey="tmc-yard.common.action.next" primary (click)="showNextStep()" [disabled]="showNextStepDisabled()"
        class="confirm-button"></sc-forward-button>
      }
      @if (showFinishButtonVisible()) {
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button dictionaryKey="tmc-yard.ui.transport.registration.action.finish" primary class="confirm-button" (click)="finish()" [disabled]="finishDisabled()"></sc-save-button>
      }
    </sc-flex>
  </sc-padding>
</sc-flex>
